// MUI components
import { styled } from '@mui/material/styles';
import CustomButton from 'components/Button/CustomButton';

export const StyledButton = styled(CustomButton)(() => ({
  borderRadius: '8px',
  padding: '8px 22px',
}));
